import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";
export let AbSize = /*#__PURE__*/function (AbSize) {
  AbSize["EXTRA_SMALL"] = "ab-size-extra-small";
  AbSize["SMALL"] = "ab-size-small";
  AbSize["MEDIUM"] = "ab-size-medium";
  AbSize["LARGE"] = "ab-size-large";
  AbSize["EXTRA_LARGE"] = "ab-size-extra-large";
  AbSize["CUSTOM"] = "ab-size-custom";
  return AbSize;
}({});
export const AbSizeContext = /*#__PURE__*/React.createContext(undefined);
AbSizeContext.displayName = "AbSizeContext";
export const WithSizeContext = InnerComponent => {
  const Component = props => {
    const context = React.useContext(AbSizeContext);
    return sizeProviderWrapper(/*#__PURE__*/React.createElement(InnerComponent, _extends({}, props, {
      className: ReactUtils.classNamesString([props.className, props.size ?? context])
    })), props, context);
  };
  Component.displayName = "SizeWrapper";
  return Component;
};
export const sizeProviderWrapper = (component, props, contextSize) => {
  if (props.size !== undefined && props.size !== contextSize) {
    return /*#__PURE__*/React.createElement(AbSizeContext.Provider, {
      value: props.size
    }, component);
  } else {
    return component;
  }
};
//# sourceMappingURL=AbSize.js.map
